const DAILY_UNIT_TYPE_ID = 3; // Days

export function isDailyUnitType(
  unitTypeId?: number,
  unitTypeName?: string
): boolean {
  if (Number(unitTypeId) === DAILY_UNIT_TYPE_ID) return true;

  const n = (unitTypeName ?? "").trim().toLowerCase();
  if (!n) return false;
  if (n.includes("week") || n.includes("month") || n.includes("fixed")) {
    return false;
  }

  return n === "days" || n.includes("daily");
}